import moment from 'moment'
import { p__getRangerDateFromThen } from '@/plugins/prototypes'

export default {
    data() {
        const getRangeDateYesterday = () => {
            const start_date = moment().subtract(1, 'd').format('YYYY-MM-DD')
            return [start_date, start_date]
        }

        const getRangeDateThisWeek = () => {
            const end_date = moment().format('YYYY-MM-DD')
            const start_date = moment().startOf('week').format('YYYY-MM-DD')
            return [start_date, end_date]
        }

        const getRangeDateThisMonth = () => {
            const end_date = moment().format('YYYY-MM-DD')
            const start_date = moment().startOf('month').format('YYYY-MM-DD')
            return [start_date, end_date]
        }

        const getRangeDateLastMonth = () => {
            const start_date = moment()
                .subtract(1, 'months')
                .startOf('month')
                .format('YYYY-MM-DD')
            const end_date = moment()
                .subtract(1, 'months')
                .endOf('month')
                .format('YYYY-MM-DD')
            return [start_date, end_date]
        }

        return {
            m__from_date: null,
            m__ranger_date: this.p__getRangerDateFromThen(7),
            m__picker_options: {
                disabledDate: this.disabledEndDate,
                onPick: this.onPick,
                shortcuts: [
                    {
                        text: this.$t('common.today'),
                        onClick(picker) {
                            picker.$emit('pick', p__getRangerDateFromThen(0))
                        }
                    },
                    {
                        text: this.$t('common.yesterday'),
                        onClick(picker) {
                            picker.$emit('pick', getRangeDateYesterday())
                        }
                    },
                    {
                        text: this.$t('date_picker.options.last_xxx_days', {
                            xxx: 7
                        }),
                        onClick(picker) {
                            picker.$emit('pick', p__getRangerDateFromThen(7))
                        }
                    },
                    {
                        text: this.$t('date_picker.options.last_xxx_days', {
                            xxx: 14
                        }),
                        onClick(picker) {
                            picker.$emit('pick', p__getRangerDateFromThen(14))
                        }
                    },
                    {
                        text: this.$t('date_picker.options.last_xxx_days', {
                            xxx: 30
                        }),
                        onClick(picker) {
                            picker.$emit('pick', p__getRangerDateFromThen(30))
                        }
                    },
                    {
                        text: this.$t('common.this_week'),
                        onClick(picker) {
                            picker.$emit('pick', getRangeDateThisWeek())
                        }
                    },
                    {
                        text: this.$t('common.this_month'),
                        onClick(picker) {
                            picker.$emit('pick', getRangeDateThisMonth())
                        }
                    },
                    {
                        text: this.$t('common.last_month'),
                        onClick(picker) {
                            picker.$emit('pick', getRangeDateLastMonth())
                        }
                    }
                ]
            }
        }
    },

    methods: {
        onPick({ maxDate, minDate }) {
            this.from_date = minDate
        },

        disabledEndDate(date) {
            const moment_date = moment(date)
            if (moment_date > moment()) {
                return true
            }

            if (this.from_date) {
                const moment_from_date = moment(this.from_date)
                const diff = moment_from_date.diff(moment_date, 'days')
                if (diff > 30 || diff < -30) {
                    return true
                }
            }
            return false
        }
    }
}
